<script setup>
import { useStore } from 'vuex';

const store = useStore();

import T from './CompanyProfileNewsTab.i18n.js';
import NewsItem from './CompanyProfileNewsItem.vue';
</script>

<template>
    <div>
        <h3>
            {{ T.header() }}
        </h3>
        <div class="container">
            <NewsItem
                v-for="(newsItem, index) in store.state.news"
                :key="index"
                :tid="newsItem.tid"
                :text="newsItem.text"
                :sent-time="newsItem.sentTime"
                :picture-url="newsItem.pictureUrl"
                class="row mb-2"
            />
        </div>
        <div
            v-if="store.state.isAdm"
            class="p-3"
        >
            <h3>
                {{ T.writeHeader() }}
            </h3>
            <p>
                {{ T.writeExplain() }}
            </p>
            <p>
                {{ T.writeFrequency() }}
            </p>
            <a :href="store.state.newsCreateUrl" class="btn btn-primary">
                {{ T.linkToCreateNewsletter() }}
            </a>
        </div>
    </div>
</template>
